export default {
  path: 'services',
  name: 'services',
  redirect: { name: 'services.index' },
  children: [
    {
      path: '',
      name: 'services.index',
      component: () => import('pages/services/IndexPage.vue'),
    },
  ],
}
